export default __webpack_public_path__ + "static/media/delete.4b93a41b.svg";